import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared-service/shared.service';

@Component({
  selector: 'app-change-password-success-popup',
  standalone: false,
  templateUrl: './change-password-success-popup.html',
  styleUrl: './change-password-success-popup.scss'
})
export class ChangePasswordSuccessPopup {

  constructor(
    private readonly router: Router,
    private readonly sharedService: SharedService,
    private readonly dialog: MatDialog
  ) { }

  close() {
    this.sharedService.clearStorage();
    this.dialog.closeAll();
    this.router.navigate(['/login']);
  }
}